import React, { useEffect, useState, useCallback, useMemo } from "react";
import Treatments from "../treatmenttable/components/treatments/Treatments";
import Treatdiagnose from "../treatmenttable/components/treatdiagnose/Treatdiagnose";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../../../../../redux/store";
import baseUrl from "../../../../../../api/baseUrl";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../../redux/loader/loaderActions";
import {
  addAditionalNote,
  addDiagnoseNote,
  addDiagnoses,
  addDiagnosesImage,
  addPrescriptions,
  addTreatmentImage,
} from "../../../../../../redux/diagnosestate/diagnoseAction";
import CryptoJS from "crypto-js";
import Container from "../../../../../../layouts/containers/Container";
import "../treatmenttable/treatmenttable.scss";

const decryptToken = (token: string, secret: string): string | undefined => {
  try {
    return CryptoJS.AES.decrypt(token, secret).toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error decrypting token:", error);
    return undefined;
  }
};

interface ImageData {
  id: string;
  url: string;
  file: any;
  base64: any;
}

function TreatmentPlan() {
  const diagnose = useSelector((state: RootState) => state.diagnose);
  const navigate = useNavigate();
  const { ID } = useParams();
  const dispatch = useDispatch();
  const [allTeatment, setallTeatment] = useState([]);
  const [formData, setFormData] = useState<ImageData[]>([]);

  const fetchData = useCallback(() => {
    if (!ID) return;

    dispatch(setloadeActive());
    baseUrl
      .get("treatment/find-treatment", {
        headers: { treatmentid: ID },
      })
      .then(async (response) => {
        setFormData([]);

        const {
          aditionalNote,
          patientComplain,
          diagnose,
          imageDiagnose,
          imageTreatment,
          prescription,
        } = response.data.data;

        function cleanDoseArray(data: any) {
          return data.map((item: any) => ({
            _id: item?._id || "",
            dose: item?.doseId || "",
            drugsId: item?.drugsId?._id || "",
            drugs: item?.drugsId?.drugs || "",
            type: item?.drugsId?.type || "",
            duration: item?.duration || "",
            frequency: item?.frequency || "",
            createdAt: item?.createdAt || "",
          }));
        }
        dispatch(addPrescriptions(cleanDoseArray(prescription) ?? []));

        dispatch(addAditionalNote(aditionalNote));
        dispatch(addDiagnoseNote(patientComplain));
        dispatch(addDiagnoses(diagnose));
        dispatch(addDiagnosesImage(imageDiagnose));
        dispatch(addTreatmentImage(imageTreatment));
        setallTeatment(response.data.data.treatment);

       
      })
      .catch(console.error)
      .finally(() => dispatch(setloadeDeactive()));
  }, [ID, dispatch]);

  useEffect(() => {
    fetchData();
  }, [ID, fetchData]);

 

  const payment = useCallback(() => {
    dispatch(setloadeActive());
    if (formData.length > 0) {
      const imagesData = formData.map((imageData) => imageData.base64);
      baseUrl
        .post(
          "treatment/addxraytoTreatement",
          { image: imagesData },
          { headers: { treatmentid: ID } }
        )
        .then(() => navigate(`/client/payments/invoice/${ID}`))
        .catch(console.error)
        .finally(() => dispatch(setloadeDeactive()));
    } else {
      navigate(`/client/payments/invoice/${ID}`);
      dispatch(setloadeDeactive());
    }
  }, [dispatch, formData, ID, navigate]);

  const diagnoseImages = useMemo(() => diagnose.treatmentImage, [diagnose]);
  const [subTreatOpen, setsubTreatOpen] = useState(false);
  const [treatment_id, settreatment_id] = useState("");
  const handleAddSubTreatmentModal = (e: any) => {
    settreatment_id(e);

    setsubTreatOpen((e) => !e);
  };
  return (
    <div className="space-y-3">
      {/* Treatment Planned Section */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <div className="px-4 py-2.5 border-b border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-bold text-slate-800">Treatment Planned</h3>
              <p className="text-xs text-slate-500 mt-0.5">{allTeatment?.filter((t: any) => t.status === "planned").length || 0} planned treatments</p>
            </div>
          </div>
        </div>
        <div className="p-3 overflow-x-auto">
          <Treatments
            allTeatment={allTeatment?.filter((t: any) => t.status === "planned")}
            setallTeatment={setallTeatment}
            handleAddSubTreatmentModal={handleAddSubTreatmentModal}
          />
          {allTeatment?.filter((t: any) => t.status === "planned").length === 0 && (
            <div className="py-8 text-center text-slate-400">
              <p className="text-xs">No planned treatments</p>
            </div>
          )}
        </div>
      </div>

      {/* Action Button */}
      <div className="flex justify-end">
        <button
          onClick={payment}
          className="px-4 py-2 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium text-xs hover:shadow-lg hover:shadow-primary/20 transition-all"
        >
          Go to Pay
        </button>
      </div>
    </div>
  );
}

export default TreatmentPlan;
